import { render, staticRenderFns } from "./EmojiAreaBeck.vue?vue&type=template&id=47c4f372&scoped=true"
import script from "./EmojiAreaBeck.vue?vue&type=script&lang=js"
export * from "./EmojiAreaBeck.vue?vue&type=script&lang=js"
import style0 from "./EmojiAreaBeck.vue?vue&type=style&index=0&id=47c4f372&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c4f372",
  null
  
)

export default component.exports